import { flatten } from "@videojs/utils/object";
//#region src/core/i18n/utils/flatten.ts
function flattenTranslations(locale, options = {}) {
	return flatten(locale, options);
}
//#endregion
export { flattenTranslations };

//# sourceMappingURL=flatten.js.map